import React, { useEffect, useState } from "react";
import axios from 'axios';
import { api_url } from '../config';
// import Tree from './tree1.png';
import ScanQR from "./ScanQR";
import TransferAcc from "./TransferAcc";
import './blink.css';
import { Grid, Paper} from '@mui/material';
export default function CountTree({ token, type }) {

  const [value, setValue] = useState([]);
  const [visible,setVisible] = useState(false);
  



  useEffect(() => {
    // setInterval(() => {
    //   fetch1();
    // }, 10000)
    console.log(1);
    fetch1();
  }, [])

  const fetch1 = async () => {
    try {
      console.log(1)
      const { data: response } = await axios({
        url: api_url + '/mission-vriksh-count-tree',
        method: 'post',
        responseType: 'json',

      })
      //  console.log(response);
      setValue(response.test);
      //  console.log(value);

    }
    catch (e) {
      alert(e.message);
    }
  }
  // const handleScanQr=()=>{
  //   setVisible(true);
  // }
 
  // const handleTransferAcc=()=>{
  //   setVisible(true);
  // }

  return (
    <>
      {
        (type == "Login")
          ? <></>
          : <>
            <div style={{ justifyContent: 'center', display: "flex" }}>
              <img src="https://reliablekota.com/mission-vriksh/tree1.png" alt="tree" height={"80px"} width={"80px"} />
              <br></br>
            </div>
          </>
      }

      {
        (type == "Dashboard")
          ? <>
            <br></br>
            <h5 style={{ textAlign: "center", fontWeight: "bold" }}>Trees Donated</h5>
          </>
          : <>
            <h1 style={{ textAlign: "center" }}>Trees Donated</h1></>
      }
      <br></br>
      {value.map(ele => <p style={{ fontSize: "40px", textAlign: "center", fontWeight: "bold", color: "#0CBA19" }}><span className="blink" >{ele.count}</span>
      </p>)}
      {/* <Paper style={{ padding: '10px', backgroundColor: 'seashell' }}> */}
      
      {
        (type == "Dashboard")
          ? <>
             <Grid container spacing={0}>
          <Grid item xs={12} md={4} lg={6}>
         <ScanQR/>
      </Grid>
      <Grid item xs={12} md={4} lg={6}>
      <TransferAcc/>
      </Grid>
         
      </Grid>
          </>
          : <>
           </>
      }
       
      
      {/* </Paper> */}
      
    </>
  )
}